module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"main_facility_link":"바로가기"},"en":{"main_facility_link":"Site link"},"ja":{"main_facility_link":"サイトに移動"}}')
  delete Component.options._Ctor
}
